module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "start"
    }
  }, [_vm._m(0), " ", _h('div', {
    staticClass: "start-message"
  }, [_h('div', {
    staticClass: "start-message__frame"
  }, [_h('div', {
    staticClass: "start-message__frame-wrap"
  }, [_h('h1', {
    staticClass: "start-message__title"
  }, ["The Eco-Schools’ Quiz"]), " ", _h('p', ["Welcome to The Eco-Schools’ Quiz! Explore the 6 different school areas and answer 30 eco-inspired, multiple-choice questions. Each question shows a great example of how you and your school can make a difference. Whether you’re taking on the quiz single-handedly, or working as a team, we hope you have lots of fun, learn some interesting facts, and leave feeling inspired! Good luck!"]), " ", _h('button', {
    staticClass: "start-trigger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goStart
    }
  }, [_h('img', {
    staticClass: "start-trigger__image",
    attrs: {
      "src": require("../../assets/svg/start/button.svg"),
      "alt": ""
    }
  }), " ", _h('span', {
    staticClass: "start-trigger__text"
  }, ["Start"])])])])]), " ", _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('ul', {
    staticClass: "scene"
  }, [_h('li', {
    staticClass: "layer scene__layer scene__layer--ground",
    attrs: {
      "data-depth": "-0.2"
    }
  }, [_h('div', {
    staticClass: "scene__illus scene__illus--ground"
  })]), " ", " ", _h('li', {
    staticClass: "layer scene__layer scene__layer--foreground",
    attrs: {
      "data-depth": "0.0"
    }
  }), " ", " ", _h('li', {
    staticClass: "layer scene__layer scene__layer--midground",
    attrs: {
      "data-depth": "0.2"
    }
  }), " ", " ", _h('li', {
    staticClass: "layer scene__layer scene__layer--background",
    attrs: {
      "data-depth": "1"
    }
  }, [_h('img', {
    staticClass: "scene__illus scene__illus--background",
    attrs: {
      "src": require("../../assets/svg/start/background.svg"),
      "alt": ""
    }
  })]), " ", " ", _h('li', {
    staticClass: "scene__sky"
  }, [_h('img', {
    staticClass: "scene__cloud scene__cloud--first",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-1.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__cloud scene__cloud--second",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-1.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__cloud scene__cloud--third",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-2.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__cloud scene__cloud--fourth",
    attrs: {
      "src": require("../../assets/svg/scene__clouds-1.svg"),
      "alt": ""
    }
  }), " ", _h('img', {
    staticClass: "scene__sun",
    attrs: {
      "src": require("../../assets/svg/scene__sun.svg"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "start-privacy"
  }, [_h('a', {
    staticClass: "start-privacy__link",
    attrs: {
      "href": "https://www.eco-schools.org.uk/privacy/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, ["Privacy Policy"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e76c89b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scenes/Start.vue
// module id = 221
// module chunks = 0